import { Box, Stack, Typography } from "@mui/material";
import React from "react";

const headingStyle = {
  fontFamily: "Saira Semi Condensed",
  fontWeight: 600,
  fontSize: { xs: "24px", sm: "30px" },
  lineHeight: "36px",
  letterSpacing: "1px",
  textAlign: "center",
  color: "#ffffff",
  textTransform: "uppercase",
};

const FlexBox = ({ value1, value2 }) => {
  return (
    <Stack
      flexDirection={"row"}
      justifyContent={"space-between"}
      alignItems={"center"}
      my={1}
    >
      <Typography
        variant="body1"
        sx={{
          fontFamily: "Montserrat",
          fontWeight: "400",
          fontSize: { xs: "11px", sm: "16px" },
          lineHeight: "36px",
          textTransform: "uppercase",
          color: "#ffffff",
        }}
      >
        {value1}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          fontFamily: "Montserrat",
          fontWeight: "400",
          fontSize: { xs: "11px", sm: "14px" },
          lineHeight: "36px",
          textTransform: "uppercase",
          color: "#ffffff",
        }}
      >
        {value2} points
      </Typography>
    </Stack>
  );
};

function PointsBox({ heading, data }) {
  return (
    <Box>
      <Box
        sx={{
          border: "5px solid #ffffff",
          borderRadius: "10px",
          py: 2,
          px: 3,
        }}
      >
        <Typography mb={3} variant="h3" sx={headingStyle}>
          {heading} <br /> break down
        </Typography>
        {data?.view && <FlexBox value1={"1 View"} value2={data?.view} />}
        {data?.like && <FlexBox value1={"1 Like"} value2={data?.like} />}

        {data?.comment && (
          <FlexBox value1={"1 Comment"} value2={data?.comment} />
        )}
        {data?.retweet && (
          <FlexBox value1={"1 Retweet"} value2={data?.retweet} />
        )}
        {data?.quoteRetweet && (
          <FlexBox value1={"1 Quote Retweet"} value2={data?.quoteRetweet} />
        )}
      </Box>
    </Box>
  );
}

export default PointsBox;
